import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  SendFeedbackRequest,
  SendFeedbackResponse,
} from '../gateway/feedback_pb';

import {
  FeedbackService as __FeedbackService,
} from '../gateway/feedback_pb_service';

@Injectable({providedIn: 'root'})
export class FeedbackService {

  constructor(private _ngZone: NgZone) {
  }

  sendFeedback(request: SendFeedbackRequest): Promise<SendFeedbackResponse>;
  sendFeedback(request: SendFeedbackRequest, metadata: grpc.Metadata): Promise<SendFeedbackResponse>;
  sendFeedback(request: SendFeedbackRequest, callback: (err: any|null, response: SendFeedbackResponse, metadata: grpc.Metadata) => void): void;
  sendFeedback(request: SendFeedbackRequest, metadata: grpc.Metadata, callback: (err: any|null, response: SendFeedbackResponse, metadata: grpc.Metadata) => void): void;

  sendFeedback(request: SendFeedbackRequest, arg1?: grpc.Metadata|((err: any|null, response: SendFeedbackResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: SendFeedbackResponse, metadata: grpc.Metadata) => void): Promise<SendFeedbackResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<SendFeedbackResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__FeedbackService.sendFeedback, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

